/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { TakeOrderLib, TakeOrderLibInterface } from '../../MerkleOrderBookTemplate.sol/TakeOrderLib';

const _abi = [
  {
    inputs: [],
    name: 'InvalidAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidHeadOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidNextOrder',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headOrder',
        type: 'tuple',
      },
      {
        components: [
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'order',
            type: 'tuple',
          },
          {
            internalType: 'bytes32[]',
            name: 'proofs',
            type: 'bytes32[]',
          },
          {
            internalType: 'uint8',
            name: 'bits',
            type: 'uint8',
          },
        ],
        internalType: 'struct OrderWithProofs',
        name: 'headsNextOrder',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'headOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'headOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'nextOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'headOrderFills',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'OrdersRoot',
            type: 'bytes32',
          },
        ],
        internalType: 'struct TakeOrderAppend',
        name: 'append',
        type: 'tuple',
      },
    ],
    name: '_takeHead',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'headOrderFills',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'ordersRoot',
            type: 'bytes32',
          },
        ],
        internalType: 'struct TakeOrderRes',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
];

const _bytecode =
  '0x61076e61003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100355760003560e01c8063dc18c1af1461003a575b600080fd5b61004d610048366004610493565b610073565b604080518251815260208084015190820152918101519082015260600160405180910390f35b6040805160608101825260008082526020820181905281830152908201358235146100ca576040517fd8ba7a3500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60006100de60808401356060870135610569565b90508086111561011a576040517f2c5211c600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d61014160c0880188610580565b6101526101008a0160e08b016105ef565b8960000160a0013588604001358960a001356040518763ffffffff1660e01b815260040161018596959493929190610668565b602060405180830381865af41580156101a2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101c691906106a4565b6101fc576040517fd8ba7a3500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60408051606081018252608085013581528435602082015260a0850135918101919091528187101561024257868160000181815161023a91906106c6565b905250610470565b6000815260208401351561039b57602084013560a086013514610291576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6102b860c0880188610580565b6102c96101008a0160e08b016105ef565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b1681526103159392919060a0808d01359160608d0135918d013590600401610668565b602060405180830381865af4158015610332573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061035691906106a4565b61038c576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b606084013560208201526103a3565b600060208201525b73__$228f495fb21f6bb55c754ccea856a59eef$__639912fa776103ca60c0890189610580565b6103db6101008b0160e08c016105ef565b604080517fffffffff0000000000000000000000000000000000000000000000000000000060e087901b1681526104299493929160a0808f0135926000928e0135918e0135906004016106de565b602060405180830381865af4158015610446573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061046a919061071f565b60408201525b9695505050505050565b6000610100828403121561048d57600080fd5b50919050565b6000806000808486036101208112156104ab57600080fd5b85359450602086013567ffffffffffffffff808211156104ca57600080fd5b6104d689838a0161047a565b955060408801359150808211156104ec57600080fd5b506104f98882890161047a565b93505060c07fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa08201121561052c57600080fd5b509295919450926060019150565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b60008282101561057b5761057b61053a565b500390565b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe18436030181126105b557600080fd5b83018035915067ffffffffffffffff8211156105d057600080fd5b6020019150600581901b36038213156105e857600080fd5b9250929050565b60006020828403121561060157600080fd5b813560ff8116811461061257600080fd5b9392505050565b81835260007f07ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff83111561064b57600080fd5b8260051b8083602087013760009401602001938452509192915050565b60a08152600061067c60a08301888a610619565b905060ff86166020830152846040830152836060830152826080830152979650505050505050565b6000602082840312156106b657600080fd5b8151801515811461061257600080fd5b600082198211156106d9576106d961053a565b500190565b60c0815260006106f260c08301898b610619565b60ff9790971660208301525060408101949094526060840192909252608083015260a09091015292915050565b60006020828403121561073157600080fd5b505191905056fea26469706673582212205c595418ca5d61f0e9ad2283942f95ca8c3be07070267b35187ed5f8be3bdd4e64736f6c634300080c0033';

type TakeOrderLibConstructorParams =
  | [linkLibraryAddresses: TakeOrderLibLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: TakeOrderLibConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  );
};

export class TakeOrderLib__factory extends ContractFactory {
  constructor(...args: TakeOrderLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, TakeOrderLib__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = 'TakeOrderLib';
  }

  static linkBytecode(linkLibraryAddresses: TakeOrderLibLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$228f495fb21f6bb55c754ccea856a59eef\\$__', 'g'),
      linkLibraryAddresses['contracts/imports/SMT.sol:SMT'].replace(/^0x/, '').toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<TakeOrderLib> {
    return super.deploy(overrides || {}) as Promise<TakeOrderLib>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TakeOrderLib {
    return super.attach(address) as TakeOrderLib;
  }
  override connect(signer: Signer): TakeOrderLib__factory {
    return super.connect(signer) as TakeOrderLib__factory;
  }
  static readonly contractName: 'TakeOrderLib';

  public readonly contractName: 'TakeOrderLib';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TakeOrderLibInterface {
    return new utils.Interface(_abi) as TakeOrderLibInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): TakeOrderLib {
    return new Contract(address, _abi, signerOrProvider) as TakeOrderLib;
  }
}

export interface TakeOrderLibLibraryAddresses {
  ['contracts/imports/SMT.sol:SMT']: string;
}
